import styled from "styled-components";
export const FilterWrapperCard = styled.div<{ showFilter: boolean }>`
  margin-top: 40px !important;
  display: ${({ showFilter }) => showFilter && "flex"};
  justify-content: space-between;
  gap: 24px;
`;
